import { render, staticRenderFns } from "./adicionarSaldoPix.vue?vue&type=template&id=7fb77fc8"
import script from "./adicionarSaldoPix.vue?vue&type=script&lang=ts"
export * from "./adicionarSaldoPix.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports